import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import T from '../../../Locale';
class FilesAttachments extends Component {
    constructor(props) {
        super(props);
        this.removeFile = this.removeFile.bind(this);
    }
    removeFile(id) {
        const { files, setData } = this.props;
        files.forEach((file, index) => {
            if (file.id === id) {
                files.splice(index, 1);
            }
        });
        setData('files', files);
    }
    render() {
        const { files } = this.props;
        if (!files.length) {
            return null;
        }
        return (_jsxs("div", { children: [_jsx("br", {}), _jsx("h5", { children: T.translate('values.documentationExisting') }), _jsx("p", { children: T.translate('values.documentationExistingDescription') }), files.map((file) => (_jsxs("div", { children: [_jsx("i", { className: "fa fa-trash-o icon-delete", "aria-hidden": "true", onClick: () => this.removeFile(file.id), title: T.translate('values.documentationExistingDelete') }), file.name] }, file.id))), _jsx("br", {})] }));
    }
}
FilesAttachments.propTypes = {
    files: PropTypes.array.isRequired,
    setData: PropTypes.func.isRequired
};
export default FilesAttachments;
